import { useState } from "react";
import { LogoImage } from "../styles/Images";
import { NavWrapper, LogoWrapper, NavLinksWrapper, MobileNavRect, MobileMenuWrapper } from "../styles/Layouts";
import { NavLink } from "../styles/Links";

import orangeRect from "../assets/images/orange-rect-hamburger.png";
import pinkRect from "../assets/images/pink-rect-hamburger.png";
import turquiozeRect from "../assets/images/turquioze-rect-hamburger.png";
import { useNavigate, useLocation } from "react-router-dom";

const NavBar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const isInEvents = location.pathname === "/events";
  const isInMenu = false;
  const isInCafe = false;

  const handleOpen = () => {
    if (mobileMenuOpen) return;
    setMobileMenuOpen(true);
    setTimeout(() => setMobileMenuOpen(false), 60000);
  };

  return (
    <NavWrapper>
      <LogoWrapper onClick={() => navigate("/")}>
        <LogoImage />
        Charcha
      </LogoWrapper>
      <NavLinksWrapper>
        <NavLink href="https://maps.app.goo.gl/35qkeFbPVGMFP2dy6" target="_blank" rel="noopener noreferrer">
          menu
        </NavLink>
        <NavLink href="https://www.instagram.com/cafe_charcha/" target="_blank" rel="noopener noreferrer">
          cafe
        </NavLink>
        <NavLink onClick={() => navigate("/events")} $isInEvents={isInEvents}>
          life drawing
        </NavLink>
        <NavLink href="https://www.meetup.com/charcha-cultural-cafe/" target="_blank" rel="noopener noreferrer">
          events
        </NavLink>
      </NavLinksWrapper>

      {/* Only for mobile */}
      <MobileMenuWrapper onClick={handleOpen}>
        <MobileNavRect $bgImage={orangeRect} $isOpen={mobileMenuOpen} $isActive={isInMenu} $translate={"translateY(1vh)"}>
          <NavLink href="https://maps.app.goo.gl/35qkeFbPVGMFP2dy6" onClick={() => setMobileMenuOpen(false)} target="_blank" rel="noopener noreferrer">
            menu
          </NavLink>
        </MobileNavRect>

        <MobileNavRect $bgImage={pinkRect} $isOpen={mobileMenuOpen} $isActive={isInCafe} $translate={"translateY(6vh)"}>
          <NavLink href="https://www.instagram.com/cafe_charcha/" onClick={() => setMobileMenuOpen(false)} target="_blank" rel="noopener noreferrer">
            cafe
          </NavLink>
        </MobileNavRect>

        <MobileNavRect $bgImage={turquiozeRect} $isOpen={mobileMenuOpen} $isActive={isInEvents} $isOnTop={true} $translate={"translateY(11vh)"}>
          <NavLink
            onClick={() => {
              setMobileMenuOpen(false);
              navigate("/events");
            }}
          >
            drawing
          </NavLink>
        </MobileNavRect>
      </MobileMenuWrapper>
    </NavWrapper>
  );
};

export default NavBar;
